import { Fragment } from "react";
import "./css/legal.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Banner from "../../images/servicio/calidad.webp";
import BannerMobile from "../../images/servicio/calidad-movil.webp";
import Image from "react-bootstrap/Image";

function InfoRescueSheets() {
    return (
        <Fragment>
            <Container fluid={true} className="banner-legal">
                <Row>
                    <Col md={12} className="px-0">
                        <Card>
                            <Image
                                src={Banner}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-none d-sm-block img2"
                                fluid
                            />
                            <Image
                                src={BannerMobile}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-block d-sm-none"
                                fluid
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-legal w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="legal-banner-titulo">
                                            Políticas de calidad
                                        </h1>
                                        <br />
                                        <h2 className="legal-banner-subtitulo">Hyundai Ecuador</h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <br></br>
            <br></br>
            <br></br>
            <Container className="legales">
                <Row>
                    <Col md={12}>
                        <Container className="pb-3">
                            <Row>
                                <Col md={12} className="mt-3">
                                    <p className="legal-texto">
                                        NEOHYUNDAI es una empresa ecuatoriana dedicada a la importación y comercialización de vehículos al por mayor, repuestos y autopartes.
                                    </p>
                                    <p className="legal-texto">
                                        La política de calidad se manifiesta mediante el compromiso con nuestros clientes y partes interesadas para satisfacer sus necesidades y requerimientos, cumpliendo las expectativas del servicio brindado.
                                    </p>
                                    <p className="legal-texto">
                                        Para ello garantizamos impulsar una cultura de calidad basada en nuestros principios organizacionales: enfoque al cliente, reconocimiento a los colaboradores, comportamiento ético, orgullo por nuestra empresa, marca y agregar valor a la empresa, que representan la cultura corporativa por la que nos esforzamos y la promesa que nos hacemos a nosotros mismos y a los grupos de interés; manteniendo un compromiso con la mejora continua, asignando todos los recursos necesarios y cumpliendo con todos los requisitos legales pertinentes.
                                    </p>
                                    <br></br>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
            <br></br>
            <br></br>
        </Fragment>
    );
}
export default InfoRescueSheets;